<template>
	<div class="design-meeting">

		<InputGroup
			title="Add Meeting Details"
			desc="Please add instructions on how they can attend this design meeting. For example a link to a Zoom meeting."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<InputTextarea
				label="Design Meeting Details"
				v-model="meetingDetails"
				:darkMode="true"
				/>

		</InputGroup>

		

		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save"
				:disabled="!canSave"
				@click="save"
				/>
		</InputGroup>

	</div>
</template>

<script>

import Button from "@/Components/Button"
import InputText from "@/Components/InputText"
import InputTextarea from "@/Components/InputTextarea"
import InputGroup from "@/Components/InputGroup"

export default {
	props: [
		'thisCase'
	],
	components: {
		Button,
		InputText,
		InputTextarea,
		InputGroup,
	},
	data: () => {
		return {
			meetingDetails: ''
		}
	},
	mounted() {
		if(this.thisCase.design_meeting_details != null){
			this.meetingDetails = this.thisCase.design_meeting_details.replace(/(<([^>]+)>)/gi, "")
		}
	},
	methods: {
		save(){

			if(this.canSave){
				this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/design-meeting`, {
					details: this.meetingDetails
				})
			}else{
				this.$toast.error('Please add design meeting details.')
			}
		},
	},
	computed: {
		canSave(){
			if(this.meetingDetails != ''){
				return true
			}else{
				return false
			}
		}
	}
}

</script>

<style scoped lang="sass">

.design-meeting
	width: 100%
	display: flex
	flex-direction: column
	position: relative

	

</style>